import { render, staticRenderFns } from "./SystemSettings.vue?vue&type=template&id=6cd9b4f6&"
import script from "./SystemSettings.vue?vue&type=script&lang=ts&"
export * from "./SystemSettings.vue?vue&type=script&lang=ts&"
import style0 from "./SystemSettings.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports